import { Close } from "@mui/icons-material";
import {
  IconButton,
  Dialog as MuiDialog,
  DialogContent as MuiDialogContent,
  DialogTitle as MuiDialogTitle,
  styled,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { memo } from "react";

const AppDialog = ({ open, title, children, onClose, DialogContentProps, ...otherProps }) => {
  const theme = useTheme();
  const isFullScreen = useMediaQuery(theme.breakpoints.down("md"));

  return (
    <Dialog open={open} fullScreen={isFullScreen} maxWidth="lg" {...otherProps}>
      <DialogTitle>{title || ""}</DialogTitle>
      <IconButton
        aria-label="close"
        onClick={event => onClose && onClose(event, "backdropClick")}
        sx={{
          position: "absolute",
          right: 16,
          top: 8,
        }}
      >
        <Close />
      </IconButton>
      <DialogContent sx={{ overflowY: "auto" }} {...DialogContentProps}>
        {children}
      </DialogContent>
    </Dialog>
  );
};

export default memo(AppDialog);

const Dialog = styled(MuiDialog)({
  "& .MuiDialog-paper": {
    display: "flex",
    flexDirection: "column",
    color: "#000000",
    backgroundColor: "#FFFFFF",
  },
});

const DialogTitle = styled(MuiDialogTitle)({
  fontSize: 20,
  fontWeight: 700,
  paddingBottom: 12,
});

const DialogContent = styled(MuiDialogContent)({
  display: "flex",
  flexDirection: "column",
  gap: 16,
  flex: 1,
  minHeight: 0,
  overflow: "hidden",
  paddingTop: "0px !important",
});
